var verticalSpot = angular.module('verticalSpot', []);
verticalSpot.controller('verticalSpotControll', ['$scope', '$log', '$http', function ($scope, $log, $http) {

    $scope.spotlight = {};

    $scope.init = function (locationID, articlesPerGenre, category, queryType) {
        $scope.locationID = locationID;
        $scope.articlesPerGenre = articlesPerGenre;
        $scope.category = category;
        $http.get(TCTServer.api + 'v1/articles/locations/' + $scope.locationID + '?data=true&postPerCategory=' + $scope.articlesPerGenre + '&queryType=topNav&category=' + $scope.category).then(function (response) {
            var data = response.data;
            fulldata = angular.fromJson(data['articleResources']);
            firstthree = fulldata.splice(0, 3);
            $scope.spotlight = firstthree[0];

            $scope.editorlinks = firstthree;

        }, function (errors) {

            TCT.warn('API call error', errors);
        });
    }

}]);


angular.bootstrap(document.getElementById("verticalspot"), ['verticalSpot']);

// JQUERY
if (window.jQuery) {
    window.jQuery(function ($) {

        if ($('#mobile-vertical-menu').length) {
            $('.menubtn').click(function () {
                if ($('#genres-menu').is(':visible')) {
                    $('#genres-menu').slideUp();
                    $(this).find('i').html('keyboard_arrow_down');
                    var vertical = $('#mobile-vertical-menu').attr('data-vertical');
                    trackCTA('mobile_genre_menu_closed', vertical);
                } else {
                    $('#genres-menu').slideDown();
                    $(this).find('i').html('keyboard_arrow_up');
                    var vertical = $('#mobile-vertical-menu').attr('data-vertical');
                    trackCTA('mobile_genre_menu_opened', vertical);
                }
            });

            $('.vertical-genre a').click(function () {
                if ($('#genres-menu').is(':visible')) {
                    $('#genres-menu').slideUp();
                    $(this).find('i').html('keyboard_arrow_down');
                }
            });
        }
    });
}